import { render, staticRenderFns } from "./VSummaryAccordion.vue?vue&type=template&id=5e426066&scoped=true"
import script from "./VSummaryAccordion.vue?vue&type=script&lang=js"
export * from "./VSummaryAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e426066",
  null
  
)

export default component.exports